/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AddressUtils__NotContract",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC165Base__InvalidInterfaceId",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__BalanceQueryZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__ERC721ReceiverNotImplemented",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__InvalidOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__MintToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__NonExistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__NotOwnerOrApproved",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__NotTokenOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__SelfApproval",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__TokenAlreadyMinted",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Base__TransferToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC721Metadata__NonExistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "EnumerableMap__IndexOutOfBounds",
        type: "error",
    },
    {
        inputs: [],
        name: "EnumerableMap__NonExistentKey",
        type: "error",
    },
    {
        inputs: [],
        name: "EnumerableSet__IndexOutOfBounds",
        type: "error",
    },
    {
        inputs: [],
        name: "SolidStateERC721__PayableApproveNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "SolidStateERC721__PayableTransferNotSupported",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "faucet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "status",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class E721__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
E721__factory.bytecode = _bytecode;
E721__factory.abi = _abi;
